import type { BatchExportSettings } from '@cartwhl/common/api/getBatch';
import type { MascotJobResponse } from '@cartwhl/common/api/getMascot';
import type { MotionRecord } from '@cartwhl/common/api/getMotionsByGroup';

import type { FileMetadata } from '../BatchComic/types';
import {
  parseMotionExportFilenameSlots,
  parseMotionExportURLSlots,
} from '../shared/batchMotionExportUrls';
import type {
  AssetLibraryBatchGroupAssetType,
  AssetLibraryGroupKind,
} from './assetLibraryGroupDetail';

export {
  isComicMogenGroupID,
  isMogenBatchGroupID,
  resolveMogenBatchExportId,
} from './assetLibraryGroupIds';

export type AssetLibraryJobPreviewState = {
  status: 'idle' | 'pending' | 'ready' | 'error';
  jobId: string | null;
  groupID: string | null;
  groupKind: AssetLibraryGroupKind | null;
  assetType: AssetLibraryBatchGroupAssetType | null;
  motions: MotionRecord[];
  mascots: MascotJobResponse[];
  batchExportSettings: BatchExportSettings | null;
  isBookmarked: boolean;
  showMainLibraryPreviewActions: boolean;
  error?: string;
};

export const INITIAL_JOB_PREVIEW_STATE: AssetLibraryJobPreviewState = {
  status: 'idle',
  jobId: null,
  groupID: null,
  groupKind: null,
  assetType: null,
  motions: [],
  mascots: [],
  batchExportSettings: null,
  isBookmarked: false,
  showMainLibraryPreviewActions: false,
};

export function motionRecordToPreviewFile(item: MotionRecord): FileMetadata {
  const exportURLs = parseMotionExportURLSlots(
    item.exportURLs ?? item.export_urls,
  );
  const exportFilenames = parseMotionExportFilenameSlots(
    item.exportFilenames ?? item.export_filenames,
  );
  const rawUrls = item.bvhURLs ?? item.bvh_urls;
  const bvhURLs = rawUrls?.map((url) => url.trim()).filter(Boolean);
  const mhrBvhs = item.mhrBvhURLs;
  const mhrIds = item.mhrIdentityJsonURLs;
  const mhrAligned =
    Boolean(mhrBvhs?.length) &&
    Boolean(mhrIds?.length) &&
    mhrBvhs!.length === mhrIds!.length;

  return {
    id: item.jobID,
    name: item.title,
    status: item.status,
    ...(exportURLs?.length ? { exportURLs, exportFilenames } : {}),
    bvhURL: item.bvhURL?.trim() ? item.bvhURL : undefined,
    bvhURLs: bvhURLs?.length ? bvhURLs : undefined,
    mhrBvhURLs: mhrAligned ? mhrBvhs : undefined,
    mhrIdentityJsonURLs: mhrAligned ? mhrIds : undefined,
    cameraFbxURL: item.cameraFbxURL?.trim()
      ? item.cameraFbxURL
      : undefined,
    studioPreviewURL: item.studioPreviewURL?.trim()
      ? item.studioPreviewURL
      : undefined,
    cwmsURL: item.cwmsURL?.trim() ? item.cwmsURL : undefined,
    sourceVideoMediaID: item.sourceVideoMediaID,
  };
}
